import { OptionsEditor } from "./OptionsEditor"
import type { ControlInspector } from "./types"

export const radioGroup: ControlInspector<"radioGroup"> = {
  Inspector: ({ field, onEdit }) => (
    <OptionsEditor
      eyebrow="Radio options"
      legend="Radio choices"
      options={field.options}
      onChange={(options) => onEdit({ options })}
    />
  ),
}
